import { render, staticRenderFns } from "./Slot.vue?vue&type=template&id=1b99f99a&scoped=true&"
var script = {}
import style0 from "./Slot.vue?vue&type=style&index=0&id=1b99f99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99f99a",
  null
  
)

export default component.exports